import React, { useEffect } from 'react'
import moment from 'moment'
import { toast, ToastContainer } from 'react-toastify'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_CUADRO_DE_MANDO } from '../../../../config/forms'
import CamposPenalizacionTransporte from '../../components/penalizacionCamiones/CamposPenalizacionCamiones'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { submitPenalizacionAcoplado, submitPenalizacionCamion } from '../../actions'

function PenalizacionDeTransporte (props) {
  const { change: formChange } = props

  useEffect(() => {
    formChange('penalizacionVencimiento', moment(new Date()).add(1, 'days').format('DD-MM-YYYY HH:mm:ss.ms'))
  }, [formChange])

  const handleSubmit = () => {
    const { motivo, patente, transporte } = props
    if (transporte) {
      if (patente) {
        if (motivo) {
          if (transporte.toUpperCase().trim() === 'CAMION') {
            props.submitPenalizacionCamion()
          } else if (transporte.toUpperCase().trim() === 'ACOPLADO') {
            props.submitPenalizacionAcoplado()
          }
          formChange('penalizacionPatente', null)
          formChange('penalizacionMotivo', null)
          formChange('penalizacionTransporte', null)
        } else {
          toast.error('Debe indicar el motivo de la penalización.')
        }
      } else {
        toast.error('Para asignar una penalización es necesario que ingrese la patente.')
      }
    } else {
      toast.error('Debe especificar el tipo de transporte a penalizar. ')
    }
  }

  const updateFechaVencimiento = (fechaV) => {
    formChange('fechaVencimiento', fechaV)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <h3>Penalización de camiones</h3>
      <div style={{ margin: '2% auto', width: '98%' }}className='container-config-sistema'>
        <CamposPenalizacionTransporte
          fechaD={props.fechaVencimiento}
          fechaH={props.fechaVencimiento}
          updateFecha={updateFechaVencimiento}
        />
        <Button
          onClick={handleSubmit}
          size='small'
          variant='contained'
          color='primary'
          style={{ outline: 'none', marginBottom: '2%' }}
        >
            Asignar penalizacion
        </Button>
      </div>

    </>
  )
}

const selector = formValueSelector(FORM_CUADRO_DE_MANDO)

const mapStateToProps = (state) => ({
  fechaVencimiento: selector(state, 'penalizacionVencimiento'),
  motivo: selector(state, 'penalizacionMotivo'),
  patente: selector(state, 'penalizacionPatente'),
  transporte: selector(state, 'penalizacionTransporte')
})

const mapActionsToProps = {
  submitPenalizacionAcoplado,
  submitPenalizacionCamion
}

const withRedux = connect(mapStateToProps, mapActionsToProps)

const withReduxForm = reduxForm({
  form: FORM_CUADRO_DE_MANDO,
  enableReinitialize: true
})

export default withRedux(withReduxForm(PenalizacionDeTransporte))
